import api from '@/api'

const SET_RATIONS = 'SET_RATIONS'
const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT'
const SET_RATIONS_LIST = 'SET_RATIONS_LIST'
const ADD_RATION = 'ADD_RATION'

const SELECT_RATION = 'SELECT_RATION'
const UNSELECT_RATION = 'UNSELECT_RATION'

export default {
  namespaced: true,

  state () {
    return {
      filters: {},
      rations: [],
      rationsList: [],
      totalCount: 0,
      selectedRation: null
    }
  },

  getters: {
    rations: (state) => state.rations,
    rationsList: (state) => state.rationsList,
    totalCount: (state) => state.totalCount,
    selectedRation: (state) => state.selectedRation
  },

  mutations: {
    [SET_RATIONS] (state, data) {
      state.rations = data
    },

    [SET_TOTAL_COUNT] (state, data) {
      state.totalCount = data
    },

    [SET_RATIONS_LIST] (state, data) {
      state.rationsList = data
    },

    [ADD_RATION] (state, data) {
      state.rations.push(data)
    },

    [SELECT_RATION] (state, data) {
      state.selectedRation = data
    },

    [UNSELECT_RATION] (state) {
      state.selectedRation = null
    }
  },

  actions: {
    async loadRations ({ commit, state }, params) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const { data, count } = await api.rations.list(state.filters)
      commit(SET_TOTAL_COUNT, count || 0)
      commit(SET_RATIONS, data || [])
    },

    async loadRationsList ({ commit }, params = {}) {
      const { data } = await api.rations.litelist(params)
      commit(SET_RATIONS_LIST, data || [])
    },

    async createRation ({ commit }, payload) {
      const { errors, data } = await api.rations.create(payload)
      commit(ADD_RATION, data)
      return { errors, data }
    },

    async loadRation ({ commit }, id) {
      const { data } = await api.rations.getById(id)
      commit(SELECT_RATION, data)
    },

    async setIngredientWeight ({ dispatch }, payload) {
      await api.rations.updateById(payload.id, payload)
      const params = { farm: payload.farm }
      dispatch('loadRations', params)
    },

    async updateSelectedRation ({ commit, dispatch, getters }) {
      const item = getters.selectedRation
      const { error } = await api.rations.updateById(item.id, item)
      const params = { farm: item.farm }
      dispatch('loadRations', params)
      if (!error) {
        commit(UNSELECT_RATION)
      }
      return error
    },

    updateRation (ctx, data) {
      return api.rations.updateById(data.id, data)
    },

    async deleteRation ({ commit, dispatch, getters }) {
      const item = getters.selectedRation
      await api.rations.deleteById(item.id)
      const params = { farm: item.farm }
      dispatch('loadRations', params)
      commit(UNSELECT_RATION)
    },

    unselectRation ({ commit }) {
      commit(UNSELECT_RATION)
    }
  }
}
